import isNumber from 'lodash/isNumber'
import Util from '@antv/f2/lib/util/common'
import Helpers from '@antv/f2/lib/util/helper'
import { resetCoordClip } from './utils'
import isArray from 'lodash/isArray'

const KEY = 'valueLabelController'
const RIGHT_PADDING = 35
const BOTTOM_PADDING = 10
const TIMEOUT = 1

const DefaultConfig = {
  position: 'top', // 标签位置
  crossArea: 'auto', // 标签相交处理
  style: {
    fontSize: 12,
    fill: '#787878',
    textAlign: 'left',
    textBaseline: 'top'
  },
  defaultOffsetX: 0,
  defaultOffsetY: 0,
  animate: {
    duration: 100,
    easing: 'quadraticOut'
  }
}

const getLandscape = () => window.matchMedia && window.matchMedia('(orientation: landscape)').matches

const checkPointValid = point => Array.isArray(point) && point.length === 2 && point.every(d => isNumber(d))

const originEqual = (newData, oldData) => {
  if (isArray(newData) && isArray(oldData)) {
    newData = newData.toString()
    oldData = oldData.toString()
  }
  if (newData === oldData) {
    return true
  }
  return false
}

const getDataArrayItemXY = (dataArrayItem, coord) => {
  const { points } = dataArrayItem
  let { x, y } = dataArrayItem
  let { start } = coord
  if (points && points[0]) {
    start = coord.convertPoint(points[0])
  }

  if (!Array.isArray(x)) {
    x = [start.x, x]
  }
  if (!Array.isArray(y)) {
    y = [start.y, y]
  }
  return { x, y }
}

const getDataArrayItem = (dataArray, label) => {
  const target = label.get('target')
  const dataArrayIndex = label.get('dataArrayIndex')
  let ret = null
  if (target && dataArrayIndex) {
    const { i, j, k } = dataArrayIndex
    const data = dataArray[i] && dataArray[i][j] && dataArray[i][j][k]
    if (data && originEqual(data._originY, target._originY)) {
      ret = data
    }
  }
  return ret
}

const previewShapeUtil = {
  checkShape() {},
  show(shape, realtime = true) {
    realtime && shape.show()
    shape.set('showNext', true)
  },
  hide(shape, realtime = true) {
    realtime && shape.hide()
    shape.set('showNext', false)
  },
  isVisible(shape, realtime = false) {
    if (realtime) {
      return shape.isVisible()
    }
    return shape.get('showNext')
  },
  setPosition(shape, position) {
    position.forEach((item) => {
      shape.attr(item[0], item[1])
    })
  },
  getPositionObj(position) {
    const newAttrs = {}
    position.forEach((attr) => {
      newAttrs[attr[0]] = attr[1]
    })
    return newAttrs
  },
  // 计算实际坐标
  getLabelPosition(shape) {
    const item = shape.get('target') || {}
    const mode = shape.get('mode') || 'x'
    const labelPosition = shape.get('position')
    const coord = shape.get('coord') || {}
    // const newX = this.getX(shape)
    // const newY = this.getY(shape)
    const position = getDataArrayItemXY(item, coord)
    if (!checkPointValid(position.x) || !checkPointValid(position.y)) return []

    const { width, height } = shape.getBBox()
    const x = position.x[1]
    const x0 = position.x[0]
    const y = position.y[1]
    const y0 = position.y[0]
    if (mode === 'y') {
      return this._getLabelYPosition(labelPosition, { x, y }, { x0, y0 }, width, height, item._originY[1] || item._originY)
    } else {
      return this._getLabelXPosition(labelPosition, { x, y }, { x0, y0 }, width, height)
    }
  },
  getLabelBBox(shape) {
    const bbox = shape.getBBox()
    const position = this.getLabelPosition(shape)
    position.forEach((item) => {
      bbox[item[0]] = item[1]
    })
    const { x, y, width, height } = bbox
    bbox.minX = x
    bbox.minY = y
    bbox.maxX = x + width
    bbox.maxY = y + height
    return bbox
  },
  _getLabelYPosition(position, { x, y }, { x0 }, width, height, _origin) {
    const outsideX = _origin < 0 ? x0 : x //负值处理
    const axis = []
    switch (position) {
      case 'top':
        axis.push(['y', y - (height / 2)])
        axis.push(['x', outsideX])
        break
      case 'outerTop':
        axis.push(['x', x])
        axis.push(['y', y - (height / 2)])
        break
      case 'bottom':
      case 'innerTop':
        axis.push(['x', outsideX - (width)])
        axis.push(['y', y - (height / 2)])
        break
      case 'center':
        axis.push(['x', ((x + x0) / 2) - (width / 2)])
        axis.push(['y', y - (height / 2)])
        break
      case 'innerBottom':
        axis.push(['x', x0])
        axis.push(['y', y - (height / 2)])
        break
      case 'left':
      case 'right':
      case 'topLeft':
      case 'topRight':
      case 'bottomRight':
      case 'bottomLeft':
      case 'innerRight':
      case 'innerLeft':
      case 'outerRight':
      case 'outerBottom':
      case 'outerLeft':
      default:
        axis.push(['y', y - (height / 2)])
        axis.push(['x', outsideX - (width / 2)])
        break
    }
    return axis
  },
  _getLabelXPosition(position, { x, y }, { y0 }, width, height) {
    const endY =  y0 < y ? y0 : y //负值处理
    const axis = []
    switch (position) {
      case 'top':
      case 'outerTop':
      case 'outside':
        axis.push(['y', endY - height])
        axis.push(['x', x - (width / 2)])
        break
      case 'left':
        axis.push(['y', endY - (height / 2)])
        axis.push(['x', x - (width)])
        break
      case 'right':
        axis.push(['y', endY - (height / 2)])
        axis.push(['x', x])
        break
      case 'bottom':
        axis.push(['y', endY - (height / 2)])
        axis.push(['x', x - (width / 2)])
      case 'innerTop':
      case 'insideTop':
        axis.push(['x', x - (width / 2)])
        axis.push(['y', endY])
        break
      case 'center':
      case 'inside':
        axis.push(['x', x - (width / 2)])
        axis.push(['y', ((y + y0) / 2) - (height / 2)])
        break
      case 'innerBottom':
      case 'insideBottom':
        axis.push(['x', x - (width / 2)])
        axis.push(['y', y0 - (height)])
        break
      case 'topLeft':
      case 'topRight':
      case 'bottomRight':
      case 'bottomLeft':
      case 'innerRight':
      case 'innerLeft':
      case 'outerRight':
      case 'outerBottom':
      case 'outerLeft':
      default:
        axis.push(['y', endY - (height / 2)])
        axis.push(['x', x - (width / 2)])
        break
    }
    return axis
  },
  setX(shape, x) {
    shape.set('newX', x)
  },
  getX(shape) {
    return shape.get('newX') || shape.attr('x')
  },
  setY(shape, y) {
    shape.set('newY', y)
  },
  getY(shape) {
    return shape.get('newY') || shape.attr('y')
  }
}

const hideNext = (labels) => {
  const prevs = []
  labels.forEach((label) => {
    const bbox = label.getBBox()
    label.show()
    const tmp = [...prevs]
    tmp.forEach((prev) => {
      const prevBbox = prev.getBBox()
      const isCross = !(bbox.maxY < prevBbox.minY || bbox.maxX < prevBbox.minX || prevBbox.maxY < bbox.minY || prevBbox.maxX < bbox.minX)
      if (isCross) {
        label.hide()
      }
    })
    if (label.isVisible()) {
      prevs.push(label)
    }
  })
  return labels
}

const flexibleX = (clipBBox, labels) => {
  if (!labels || !labels[0]) return
  const position = labels[0].get('position')
  const shouldFromLeft = position === 'innerBottom'
  let prev = null
  if (shouldFromLeft) {
    labels.reverse()
  }
  labels.forEach((label) => {
    const bbox = previewShapeUtil.getLabelBBox(label)
    previewShapeUtil.show(label)
    const bboxMinX = bbox.minX
    const bboxMaxX = bbox.maxX
    if (shouldFromLeft) {
      // 超出左侧
      if (bboxMinX < clipBBox.minX) {
        previewShapeUtil.hide(label)
        return
      }
      if (prev) {
        const prevBbox = previewShapeUtil.getLabelBBox(prev)
        const prevMinX = prev.get('newX') || prevBbox.x
        const prevMaxX = prevMinX + prevBbox.width
        const cross = bboxMinX - prevMaxX

        // 重合
        if (prevMinX === bboxMaxX) {
          previewShapeUtil.hide(label)
          return
        }

        // 重叠
        if (cross < 0) {
          previewShapeUtil.hide(label)
        }
      }
    } else {
      // 超出右侧
      // let overMaxX = coord.x.end
      // if (shouldPaddingRight) {
      //   overMaxX += RIGHT_PADDING + 10
      // }
      // if (bboxMaxX > overMaxX) {
      //    previewShapeUtil.hide(label)
      //   return
      // }
      if (prev) {
        const prevBbox = previewShapeUtil.getLabelBBox(prev)
        const prevMinX = prevBbox.minX
        const cross = prevMinX - bboxMaxX

        // 重叠 || 相同值
        if (cross < 0 || prevMinX === bboxMaxX) {
          previewShapeUtil.hide(label)
        }
        // console.log(label.get('target')._origin.name, label.attr('text'), label.get('target')._origin.type, cross, prevMinX, bboxMaxX)
      }
      // 超出左侧
      if (bboxMinX < clipBBox.minX) {
        previewShapeUtil.hide(label)
      }
    }
    if (previewShapeUtil.isVisible(label)) {
      prev = label
    }
  })
}

const flexibleY = (clipBBox, labels) => {
  /* canvas 坐标
  ** 0 - > 100 x坐标
  ** |
  ** v
  ** 100
  ** y 坐标
  */
  // 由上到下的遍历
  let prev = null
  labels.forEach((label) => {
    const bbox = previewShapeUtil.getLabelBBox(label)
    previewShapeUtil.show(label, true)
    // 超出顶部
    // if (bbox.minY < clipBBox.minY) {
    //  previewShapeUtil.hide(label)
    //   return
    // }
    if (prev) {
      const prevBbox = previewShapeUtil.getLabelBBox(prev)
      const prevMaxY = prevBbox.maxY
      const cross = bbox.minY - prevMaxY

      // 重合
      if (prevBbox.minY === bbox.maxY) {
        previewShapeUtil.hide(label)
      }

      if (cross < 0) {
        // 重叠区域不超过字高则设置 y 为上一标签的 maxY, 否则隐藏
        // if (bbox.height + cross > 0) {
        //   previewShapeUtil.setY(label, prevMaxY) // 预设置新的位置
        // } else {
        //   previewShapeUtil.hide(label)
        // }
        previewShapeUtil.hide(label)
      }
      // console.log(label.get('target')._origin.name, label.attr('text'), label.get('target')._origin.type, cross, bbox.minY, prevMaxY, previewShapeUtil.isVisible(label), previewShapeUtil.getLabelBBox(label).y)
    }
    // 超出底部
    const { maxY } = previewShapeUtil.getLabelBBox(label)
    if (maxY > clipBBox.maxY) {
      previewShapeUtil.hide(label)
    }
    if (previewShapeUtil.isVisible(label)) {
      prev = label
    }
  })
}

const flexibe = (clipBBox, groups, type) => {
  groups.forEach((group) => {
    if (type === 'x') {
      flexibleY(clipBBox, group.children)
    }
    if (type === 'y') {
      flexibleX(clipBBox, group.children)
    }
    group.done()
  })
}

const checkGroupBoundary = (coord, groups, type) => {
  if (!coord || !coord.x || !coord.y || groups.length <= 0) {
    return
  }
  groups.forEach((group) => {
    if (type === 'x') {
      if (group.minX < coord.x.start) {
        group.hide()
      }
      if (group.maxX > coord.x.end) {
        group.hide()
      }
    }
    if (type === 'y') {
      if (group.minY > coord.y.start) {
        group.hide()
      }
      if (group.maxY < coord.y.end) {
        group.hide()
      }
    }
  })
}

class LabelGroup {
  constructor(type, key, isPrev) {
    this.children = []
    this.minX = ''
    this.minY = ''
    this.maxX = ''
    this.maxY = ''
    this.visible = true
    this.type = type
    this.key = key
    this.add = this.add.bind(this)
    this.isPrev = isPrev
  }
  add(child) {
    this.children.push(child)
  }
  _sort() {
    this.children.sort((a, b) => {
      const aBox = a.getBBox()
      const bBox = b.getBBox()
      let coordKey = 'y'
      let order = 1
      if (this.type === 'y') {
        coordKey = 'x'
        order = -1
      }
      return order * (aBox[coordKey] - bBox[coordKey])
    })
    return this.children
  }
  hide() {
    this.children.forEach((child) => {
      previewShapeUtil.hide(child, this.isPrev)
    })
    this.visible = false
  }
  show() {
    this.children.forEach((child) => {
      previewShapeUtil.show(child, !this.isPrev)
    })
    this.visible = true
  }
  getBBox() {
    return {
      minX: this.minX,
      minY: this.minY,
      maxX: this.maxX,
      maxY: this.maxY,
      x: this.minX,
      y: this.minY
    }
  }
  _getChildBBox(child) {
    let {
      minX,
      minY,
      maxX,
      maxY,
      x,
      y
    } = child.getBBox()
    const attrs = previewShapeUtil.getLabelPosition(child) || []
    const newAttrs = {}
    attrs.forEach((attr) => {
      newAttrs[attr[0]] = attr[1]
    })
    if (newAttrs.x && newAttrs.x !== x) {
      minX = newAttrs.x
      maxX += newAttrs.x - x
      x = minX
    }
    if (newAttrs.y && newAttrs.y !== y) {
      minY = newAttrs.y
      maxY += newAttrs.y - y
      y = minY
    }

    return {
      minX, minY, maxX, maxY, x, y
    }
  }
  done() {
    this.minX = ''
    this.minY = ''
    this.maxX = ''
    this.maxY = ''
    this._sort().forEach((child) => {
      const bbox = this._getChildBBox(child);
      (!this.minX || bbox.minX < this.minX) && (this.minX = bbox.minX);
      (!this.minY || bbox.minY < this.minY) && (this.minY = bbox.minY);
      (!this.maxX || bbox.maxX > this.maxX) && (this.maxX = bbox.maxX);
      (!this.maxY || bbox.maxY > this.maxY) && (this.maxY = bbox.maxY)
    })
    return this
  }
  isVisible() {
    return this.visible
  }
  set(key, val) {
    this[key] = val
    return val
  }
}
class ValueLabelController {
  constructor({ parentContainer, chart }) {
    this.parent = parentContainer
    this.chart = chart

    // todo 自定义配置
    Util.mix(this, DefaultConfig)

    this.container = this.parent.addGroup({
      className: 'valueLabelContainer'
    })

    this.lineContainer = this.parent.addGroup({
      className: 'valueLabelLineContainer',
    })

    // 识别放大 需要重新计算碰撞
    this.prevScale = null

    this.shouldInit = true

    // 横竖屏
    this.landscape = getLandscape()

    this.config = {}

    this.prevDataArray = []

    // 动画防抖
    this.timer = null
  }

  addClip() {
    const geoms = this.chart.get('geoms')
    Array.isArray(geoms) && geoms.forEach((g) => {
      const config = g.get('valueLabel') || {}
      const shouldPaddingRight = !!config.shouldPaddingRight
      const coord = this.chart.get('coord')
      const labelContainer = this.container
      if (labelContainer) {
        const labelClip = resetCoordClip(Helpers.getClip(coord))
        const { width, height } = labelClip.get('attrs')
        labelClip.set('canvas', this.canvas)
        if (shouldPaddingRight) {
          labelClip.attr('width', width + RIGHT_PADDING)
        }
        if (this.getMode() === 'y') {
          labelClip.attr('height', height - BOTTOM_PADDING)
        }
        labelContainer.attr('clip', labelClip)
      }
    })
  }

  paint() {
    this.addClip()
    if (this.config.chartType === 'funnel') {
      this.clear()
      this.lineContainer.clear()
      this.init()
      return
    }
    if (this.shouldInit) {
      this.init()
      this.shouldInit = false
    } else if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
      this.update()
    } else {
      this.timer = setTimeout(() => {
        this.update(true)
        this.timer = null
      }, TIMEOUT)
    }
    this.prevDataArray = this.getCurrentData()
  }

  init() {
    const { chart } = this
    const geoms = chart.get('geoms')
    Array.isArray(geoms) && geoms.forEach((geom, i) => {
      const config = geom.get('valueLabel')
      if (!config || config.show === false) {
        return
      }
      this.config = { ...this.config, ...config }
      const dataArray = geom.get('dataArray')

      Array.isArray(dataArray) && dataArray.forEach((data, j) => {
        Array.isArray(data) && data.forEach((item, k) => {
          this.paintLabel(item, config, { i, j, k })
        })
      })
    })
    if (this.config.chartType === 'funnel') {
      this.setFunnelLabels()
      return
    }
    this.disposeLabelsCrossArea()
  }

  paintLabel(item, config, dataArrayIndex) {
    const { chart } = this
    const coord = chart.get('coord')
    // const start = coord.convertPoint({ x: 0, y: 0 })
    const { _origin } = item || {}
    const { x, y } = getDataArrayItemXY(item, coord)
    const mode = this.getMode()
    const { container, style } = this
    const { position, fontSize, fill } = config || {}
    const { formatFn } = _origin || {}
    const text = (formatFn && formatFn(_origin)) || ''
    if (!checkPointValid(x) || !checkPointValid(y)) return

    const shape = container.addShape('text', {
      className: 'valueLabel',
      attrs: {
        x: x[1],
        y: y[1],
        text,
        ...this.style,
        fill: fill || (style && style.fill),
        fontSize,
      },
    })

    shape.set('mode', mode)
    shape.set('coord', coord)
    shape.set('x0', x[0])
    shape.set('y0', y[0])
    shape.set('position', position)
    shape.set('axis', { x, y })
    shape.set('target', item)
    shape.set('config', config)
    shape.set('parent', container)
    shape.set('dataArrayIndex', dataArrayIndex)
  }

  update(hasAnimate) {
    const { chart, animate } = this
    const coord = chart.get('coord')
    // const start = coord.convertPoint({ x: 0, y: 0 })
    const labels = this.container.getChildren()
    const currentData = this.getCurrentData()
    Array.isArray(labels) && labels.filter(label => label.get('type') === 'text').forEach((label) => {
      const newItem = getDataArrayItem(currentData, label)
      if (newItem) {
        const newAxis = getDataArrayItemXY(newItem, coord)
        label.set('x0', newAxis.x[0])
        label.set('y0', newAxis.y[0])
        label.set('axis', newAxis)
        label.set('target', newItem)
      } else {
        previewShapeUtil.hide(label)
      }
    })
    if (this.config.chartType === 'funnel') {
      this.lineContainer.clear()
      this.renderLabelVisble()
      this.setFunnelLabels()
      return
    }
    this.disposeLabelsCrossArea(hasAnimate && animate)
  }

  setFunnelLabels() {
    const coord  = this.chart.get('coord')
    const labels = this.container.getChildren()
    Array.isArray(labels) && labels.forEach((label) => {
      this.setFunnelLabel(label, coord)
    })
  }

  setFunnelLabel(label, coord) {
    const { width, height, y } = previewShapeUtil.getLabelBBox(label)
    const parent = this.lineContainer
    const target = label.get('target')
    const fill = target.color
    const { x } = coord
    const lineStartX = (x.start + x.end) / 2
    label.attr('y', y)
    label.attr('x', x.end - width)
    const lineEndX = x.end - width - 5
    const lineY = y + (height / 2)
    if (lineEndX > lineStartX) {
      parent.addShape('line', {
        className: 'funnelLabelLine',
        attrs: {
          x1: lineStartX, // 线段起始点 x 坐标
          y1: lineY, // 线段起始点 y 坐标
          x2: lineEndX, // 线段结束点 x 坐标
          y2: lineY, // 线段结束点 y 坐标
          lineWidth: 1, // html5 canvas 绘图属性
          strokeStyle: fill, // html5 canvas 绘图属性
          lineCap: 'round' // html5 canvas 绘图属性
        }
      })
    }
  }

  getCurrentData() {
    const { chart } = this
    const geoms = chart.get('geoms')
    return Array.isArray(geoms) ? geoms.map(geom => (geom.get('dataArray') || [])) : []
  }

  checkDataIsChanged() {
    const { chart } = this
    const geoms = chart.get('geoms')
    const dataArray = Array.isArray(geoms) ? geoms.map(geom => (geom.get('dataArray') || [])) : []
    let changed = false
    if (dataArray.length !== this.prevDataArray.length) {
      changed = true
      return changed
    }
    dataArray.forEach((currentData, idx) => {
      const prevData = this.prevDataArray[idx]
      if (prevData.length !== currentData.length) {
        changed = true
      }
    })
    return changed
  }

  disposeLabelsCrossArea(animate) {
    const { chart, prevScale } = this
    // 缩放比例
    const controller = chart.get('elasticController')
    const scales = controller && controller.getScale()
    let scale = 1
    if (Array.isArray(scales) && scales.length === 2) {
      scale = Math.max(scales[0], scales[1])
    }
    // 缩放&初始化 || 平移
    const shouldShowAll = scale === prevScale || scale >= 0.98
    // console.log('缩放比例：', scale)
    this.calcLabelsHit(shouldShowAll)
    this.renderLabelVisble(animate)
    this.prevScale = scale
  }

  renderLabelVisble(animateConfig) {
    const labels = this.container.getChildren() || []
    labels.forEach((label) => {
      const position = previewShapeUtil.getLabelPosition(label)
      if (!animateConfig) {
        previewShapeUtil.setPosition(label, position)
        previewShapeUtil.isVisible(label) ? label.show() : label.hide()
        return
      }
      const newAttrs = previewShapeUtil.getPositionObj(position)
      label.animate().to({
        attrs: newAttrs,
        ...animateConfig,
      }).onUpdate(() => {
        previewShapeUtil.isVisible(label) ? label.show() : label.hide()
      })
    })
  }

  getGroup(labels, mainAxisType) {
    if (!labels) return []
    const groupCache = {}
    labels.filter(label => label.get('type') === 'text')
      .forEach((label) => {
        const key = label.get('axis')[mainAxisType]
        if (!groupCache[key]) {
          groupCache[key] = new LabelGroup(mainAxisType, key, true)
        }
        groupCache[key].add(label)
      })
    return  Object.keys(groupCache)
      .sort((a, b) => (Number(a) - Number(b)))
      .map(key => groupCache[key].done())
  }

  getMode(config) {
    config = config || this.config
    const mode =  config.mode || 'x'
    return mode
  }

  calcLabelsHit(checkBoound = true) {
    const coord = this.chart.get('coord')
    const clip = this.container.attr('clip')
    const mainAxisType = this.getMode()
    if (!mainAxisType) {
      return
    }
    const labels = this.container.getChildren()
    // 获取分组
    const groups = this.getGroup(labels, mainAxisType)
    !checkBoound && checkGroupBoundary(coord, groups, mainAxisType)
    hideNext(groups.filter(group => group.visible))
    // console.log('[第一组显示标签1]', groups[0] && groups[0].children.filter(item => previewShapeUtil.isVisible(item)))
    flexibe(clip.getBBox(), groups.filter(group => group.visible), mainAxisType)
    // console.log('[第一组显示标签2]', groups[0] && groups[0].children.filter(item => previewShapeUtil.isVisible(item)))
  }

  clearInner() {
    const dataChanged = this.checkDataIsChanged()
    const landscape = getLandscape()
    if (dataChanged || this.landscape !== landscape) {
      this.clear()
      this.landscape = landscape
    }
  }

  clear() {
    this.container && this.container.clear()
    this.shouldInit = true
  }
}

export default {
  init(chart) {
    const controller = new ValueLabelController({
      parentContainer: chart.get('frontPlot'),
      chart,
    })

    chart.set(KEY, controller)
  },

  afterGeomDraw(chart) {
    // console.log('[值标签-afterGeomDraw]')
    const controller = chart.get(KEY)
    if (controller) {
      controller.clearInner()
      controller.paint()
    }
  },

  clear(chart) {
    // console.log('[值标签-clear]')
    const controller = chart.get(KEY)
    if (controller) {
      controller.clear()
    }
  },

  clearInner() {
    // 在 afterGeomDraw 之前执行，不能拿到数据对比
  },
}
